import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-annual-prize-distribution',
  templateUrl: './annual-prize-distribution.component.html',
  styleUrls: ['./annual-prize-distribution.component.scss']
})
export class AnnualPrizeDistributionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
